// Capability-detection entry point. The branch exists because swapping decoders without
// touching the UI is the entire point of the Decoder interface. Ported from event-connect's
// scanner (decoder/create-decoder.ts) unchanged.
//
// WorkerDecoder: identical decoding, but off the render thread — zxing's readBarcodes runs
// synchronously on its calling thread, so on the main thread it is a real block competing with
// React and camera compositing 15x/second. WasmDecoder stays as the fallback wherever Workers
// aren't available.
//
// NativeDecoder (BarcodeDetector) is deliberately NOT here: verified (event-connect, 2026-08-03)
// that Safari on iOS still does not implement it, so it buys nothing on the devices this step
// targets and is dropped rather than ported.

import { WasmDecoder } from './wasm-decoder'
import { WorkerDecoder, workersAvailable } from './worker-decoder'
import type { Decoder } from './types'

export function createDecoder(): Decoder {
  const decoder: Decoder = workersAvailable() ? new WorkerDecoder() : new WasmDecoder()
  return decoder
}
